/**
 *
 * @module events/group/extender
 * @author Greg Babula [greg.babula@mlb.com]
 *
 */

/**
 *
 * @function eventGroup
 * @param {Object} master
 * @param {Object} model
 * @param {Object} viewModel
 * @desc attaches custom events to all core dependencies
 *
 */
function eventGroup(master={}, model={}, viewModel={}) {

    //
    // custom events
    //

}

export default eventGroup;
